<template>
  <!-- 用电综览 -->
  <div class="electricOverview">
    <div class="con">
        <div class="topcard">
           <div class="card-item">
                <div class="mynum">
                    <div class="mynumitem">
                        <div class="numtit">今日用汽量</div>
                        <div class="jutinum">1200 <span>t</span></div>
                    </div>
                    <div class="mynumitem mynumitem2">
                      <div class="numtit">折算碳排放量</div>
                        <div class="jutinum">1200 <span>tCO2</span></div>
                    </div>
                </div>
                <div class="tongbihuanbi">
                    <div class="tongbi">
                      <div class="bititle">同比</div>
                      <!-- <i class="el-icon-caret-bottom"></i> -->
                      <i class="el-icon-caret-top"></i>
                      <div class="binum rednum">20.00%</div>
                    </div>
                    <div class="tongbi">
                      <div class="bititle">环比</div>
                      <i class="el-icon-caret-bottom"></i>
                      <!-- <i class="el-icon-caret-top"></i> -->
                      <div class="binum greednum">20.00%</div>
                    </div>
                </div>
           </div>
           <div class="card-item">
                <div class="mynum">
                    <div class="mynumitem">
                        <div class="numtit">本月用汽量</div>
                        <div class="jutinum">1200 <span>t</span></div>
                    </div>
                    <div class="mynumitem mynumitem2">
                      <div class="numtit">折算碳排放量</div>
                        <div class="jutinum">1200 <span>tCO2</span></div>
                    </div>
                </div>
                <div class="tongbihuanbi">
                    <div class="tongbi">
                      <div class="bititle">同比</div>
                      <i class="el-icon-caret-top"></i>
                      <div class="binum rednum">20.00%</div>
                    </div>
                    <div class="tongbi">
                      <div class="bititle">环比</div>
                      <i class="el-icon-caret-bottom"></i>
                      <div class="binum greednum">20.00%</div>
                    </div>
                </div>
           </div>
          <div class="card-item">
                <div class="mynum">
                    <div class="mynumitem">
                        <div class="numtit">今年用汽量</div>
                        <div class="jutinum">1200 <span>t</span></div>
                    </div>
                    <div class="mynumitem mynumitem2">
                      <div class="numtit">折算碳排放量</div>
                        <div class="jutinum">1200 <span>tCO2</span></div>
                    </div>
                </div>
                <div class="tongbihuanbi">
                    <div class="tongbi">
                      <div class="bititle">同比</div>
                      <i class="el-icon-caret-top"></i>
                      <div class="binum rednum">20.00%</div>
                    </div>
                    <div class="tongbi">
                      <div class="bititle">环比</div>
                      <i class="el-icon-caret-bottom"></i>
                      <div class="binum greednum">20.00%</div>
                    </div>
                </div>
           </div>
        </div>
        <div class="secondcon">
            <div class="secondleft">
               <div class="untitle">
                  <div class="unname">设备能耗分析</div>
                  <div class="unitdiv">单位：kWh</div>
               </div>
               <div class="devnneghao">
                  <div class="roundchart"><div id="chart_example" style="width:100%;height:100%;"></div><div class="zongnum">总能耗：<span>1000</span> kWh</div></div>
                  <div class="rightnum">
                      <el-scrollbar style="height:100%;width: 100%;">
                      <div class="devitem">
                          <div class="devname"><span></span> 空调</div>
                          <div class="devnum">40.0% <span>150.00</span></div>
                      </div>
                       <div class="devitem">
                          <div class="devname"><span style="backgroundColor:#91cc75"></span> 照面</div>
                          <div class="devnum">40.0% <span>150.00</span></div>
                      </div>
                      <div class="devitem">
                          <div class="devname"><span style="backgroundColor:#fac858"></span> 插座</div>
                          <div class="devnum">40.0% <span>150.00</span></div>
                      </div>
                       <div class="devitem">
                          <div class="devname"><span style="backgroundColor:#ee6666"></span> 其他</div>
                          <div class="devnum">40.0% <span>150.00</span></div>
                      </div>
                       
                      
                       </el-scrollbar>
                  </div>
               </div>
            </div>
            <div class="secondright">
               <div class="untitle">
                  <div class="unname">区域能耗分析</div>
                  <div class="unitdiv">单位：kWh</div>
               </div>
               <div class="devnneghao"><div id="middle2" style="width:100%;height:100%;"></div></div>
            </div>
        </div>
        <div class="threecon">
           <div class="untitle">
                  <div class="unname">能源分析</div>
                  <div class="unitdiv">最大值：<span>100 kWh</span></div>
           </div>
           <div class="devnneghao"><div id="proportion" style="width:100%;height:100%;"></div></div>
        </div>
    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts';
var proportion,middle2,myChart;
  export default {

    data () {
      return {
         roundoption:{
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '5%',
              left: 'center',
              show:false,
            },
            series: [
              {
                name: 'Access From',
                type: 'pie',
                radius: ['100%', '75%'],
                avoidLabelOverlap: false,
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: false,
                    fontSize: 40,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: [
                  { value: 1048, name: '空调' },
                  { value: 735, name: '照面' },
                  { value: 735, name: '插座' },
                  { value: 580, name: '其他' },
                ],
                
              }
            ]
        },
        //能源分析
        proportionDataLine2: {
          grid: {
            top: 10,
            bottom: 25,
            left: 50,
            right: 10,
            containLabel: false // 是否包含坐标轴刻度标签，默认为false
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          color: ["#1F57F1"],
          legend: {
            show:false,
            data: ['综合效率'],
            bottom: 0,
            textStyle: {
              fontSize: 12,
              color: '#666666'
            },
            itemStyle: {
              symbol: 'circle'
            }
          },
          xAxis: {
            splitLine: {  // 控制x轴网格线颜色
              show: true,
              lineStyle: {
                color: '#EBEBEB',
                type: 'dashed'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#EBEBEB' // 修改刻度线颜色为蓝色
              }
            },
            type: 'category',
            data: ['1日','2日','3日','4日','5日','6日','7日','8日','9日','10日','11日'],
            axisLabel: {
              rotate: 0,
              textStyle: {
                color: '#666666'
              }
            },
          },
          yAxis: {
            splitLine: {  // 控制x轴网格线颜色
              show: true,
              lineStyle: {
                color: '#EBEBEB',
                type: 'dashed'
              }
            },
            type: "value",
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,
              textStyle: {
                color: '#666666'
              },
            },
            axisLine: {
              lineStyle: {
                color: '#EBEBEB' // 修改刻度线颜色为蓝色
              }
            }
          },
          series: [
            {
              name: "综合效率",
              data: [10,20,30,10,50],
              type: "line",
              // symbol: 'none', // 去掉小圆点
              smooth: true,
              areaStyle: {
                color: 'rgba(31, 87, 241, 0.1)' // 设置面积图的填充颜色为蓝色，透明度为 0.3
              }


            },

          ],
        },
        //区域能耗
        proportionDataBar: {
          grid: {
            top: 10,
            bottom: 25,
            left: 30,
            right: 10,
            containLabel: false // 是否包含坐标轴刻度标签，默认为false
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          color: ["#0052CC",'#FFAA2B'],
          legend: {
            show:false,
            data: ['充电','放电'],
            bottom: 0,
            textStyle: {
              fontSize: 12,
              color: '#666666'
            },
            itemStyle: {
              symbol: 'circle'
            }
          },
          xAxis: {
            splitLine: {  // 控制x轴网格线颜色
              show: true,
              lineStyle: {
                color: '#EBEBEB',
                type: 'dashed'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#EBEBEB' // 修改刻度线颜色为蓝色
              }
            },
            type: 'category',
            data: ['1区','2区','3区','4区','5区'],
            axisLabel: {
              rotate: 0,
              textStyle: {
                color: '#666666'
              }
            },
          },
          yAxis: {
            splitLine: {  // 控制x轴网格线颜色
              show: true,
              lineStyle: {
                color: '#EBEBEB',
                type: 'dashed'
              }
            },
            type: "value",
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,
              textStyle: {
                color: '#666666'
              },
            },
            axisLine: {
              lineStyle: {
                color: '#EBEBEB' // 修改刻度线颜色为蓝色
              }
            }
          },
          series: [
            {
              name: "空调",
              data: [10,20,30,10,50],
              type: "bar",
              smooth: true,
              stack: '总量', // 堆叠的名称
              barWidth: 12 // 设置柱状图的宽度为 20
            },
            {
              name: "照面",
              data: [10,20,30,10,50],
              type: "bar",
              smooth: true,
              stack: '总量', // 堆叠的名称
              barWidth: 12 // 设置柱状图的宽度为 20
            },

          ],
        },
      };
    },


    mounted () {
     this.init()

    },
    methods: {
      //初始化图表
      init(){
          myChart=echarts.init(document.getElementById("chart_example"));
          myChart.setOption(this.roundoption);

          proportion=echarts.init(document.getElementById("proportion"));
          proportion.setOption(this.proportionDataLine2);

            middle2=echarts.init(document.getElementById("middle2"));
          middle2.setOption(this.proportionDataBar);
      },

    }
  };
</script>

<style lang="scss" scoped>
  .electricOverview {
    position: relative;
    overflow: hidden;
    .con {
       width: 100%;
       height: 100%;
       .topcard {
         width: 100%;
         height: 132px;
         display: flex;
         align-content: center;
         justify-content: space-between;
         .card-item {
           width: calc(33.3% - 5.5px);
           height: 100%;
           background-color: #fff;
           border-radius: 4px;
           padding-top: 20px;
           box-sizing: border-box;
           .mynum {
             width: 100%;
             height: calc(100% - 42px);
             display: flex;
             align-items: center;
             padding-bottom: 12px;
             box-sizing: border-box;
             .mynumitem {
                 width: 50%;
                 height: 100%;
                 padding-left: 20px;
                 box-sizing: border-box;
                 .numtit {
                   font-size: 14px;
                   color: #4D4D4D;
                   margin-bottom: 8px;
                 }
                 .jutinum {
                   font-size: 28px;
                   color: #1A1A1A;
                   font-weight: bold;
                   span {
                     font-size: 13px;
                     font-weight: normal;
                     color: #4D4D4D;
                   }
                 }
             }
             .mynumitem2 {
               border-left: 1px solid #EBEBEB;
             }
           }
           .tongbihuanbi {
             width: 100%;
             height: 42px;
             display: flex;
             align-items: center;
             padding: 0px 20px;
             border-top: 1px solid  #EBEBEB;
             .tongbi {
                display: flex;
                align-items: center;
                margin-right: 20px;
                .bititle {
                   font-size: 14px;
                   color:#999999;
                   margin-right: 6px;
                }
                .binum {
                   font-size: 14px;
                   font-weight: bold;
                   margin-left: 3px;
                }
                .rednum {
                    color: #FF403C;
                }
                .greednum {
                   color: #22733B;
                }
                .el-icon-caret-top {
                   color: #FF403C;
                }
                .el-icon-caret-bottom {
                   color: #22733B;
                }

             }
             .huanbi {
               
             }
           }
         }
       }
       .untitle {
         width: 100%;
         display: flex;
         align-items: center;
         justify-content: space-between;
         .unname {
           color: #1A1A1A;
           font-size: 16px;
         }
         .unitdiv {
           font-size: 14px;
           color: #4D4D4D;
           span { 
             font-size: 14px;
             color: #FF8623;
             font-weight: bold;
           }
         }
       }
       .secondcon {
         width: 100%;
         height: 350px;
         margin: 8px 0px;
         display: flex;
         .secondleft {
           width: calc(33.3% - 5.5px);
           height: 100%;
           background-color: #fff;
           border-radius: 4px;
           margin-right: 8px;
           padding: 20px;
           box-sizing: border-box;
           .devnneghao {
             width: 100%;
             height: calc(100% - 65px);
             display: flex;
             align-items: center;
             justify-content: center;
             margin-top: 30px;
             padding-left: 12px;
             box-sizing: border-box;
             .roundchart {
               width: 160px;
               height: 160px;
               margin-right: 40px;
               text-align: center;
               .zongnum {
                margin-top: 10px;
                font-size: 14px;
                span {
                   font-size: 15px;
                }
               }
              //  background-color: red;
             }
             .rightnum {
               height: 100%;
             }
             .devitem {
                margin-bottom: 16px;
                .devname {
                    color: #1A1A1A;
                    font-size: 14px;
                    span {
                       width: 12px;
                       height: 12px;
                       display: inline-block;
                       border-radius: 2px;
                       background-color: #5470c6;
                       position: relative;
                       top: 1px;
                    }
                }
                .devnum {
                   margin-top: 4px;
                   font-size: 15px;
                   color: #4D4D4D;
                   span {
                    font-size: 15px;
                     color: #1A1A1A;
                     margin-left: 6px;
                   }
                }

             }
           }
         }
         .secondright {
           flex: 1;
           height: 100%;
           background-color: #fff;
           border-radius: 4px;
           padding: 20px;
           box-sizing: border-box;
           .devnneghao {
               width: 100%;
              height: calc(100% - 42px);
              display: flex;
              align-items: center;
              justify-content: center;
              padding-bottom: 20px;
              margin-top: 20px;
              box-sizing: border-box;
              // background-color: red;
           }
         }
       }
       .threecon {
         width: 100%;
         height: calc(100% - 500px);
         background-color: #fff;
         margin-top: 8px;
         border-radius: 4px;
         padding: 20px;
           box-sizing: border-box;
           .devnneghao {
               width: 100%;
              height: calc(100% - 42px);
              display: flex;
              align-items: center;
              justify-content: center;
              padding-bottom: 20px;
              margin-top: 20px;
              box-sizing: border-box;
              // background-color: red;
           }
       }
    }
  }
</style>